import { Row, RowData } from '@tanstack/react-table'

export const isParent = <T extends RowData>(row: Row<T>): boolean => row.depth === 0
